export const works = [
  {
    id: "se-qing-nan-nv-1996",
    title: "色情男女",
    enTitle: "Viva Erotica",
    year: 1996,
    type: "电影",
    genre: "剧情",
    director: "尔冬升",
    role: "梦娇",
    rating: 8.1,
    popularity: 86,
    poster:
      "https://readdy.ai/api/search-image?query=a%20young%20woman%20gazing%20at%20reflected%20neon%20light%20in%20a%20retro%20Hong%20Kong%20night%20street%20cinematic%20Chinese%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-seqingnanv-1996&orientation=portrait",
    synopsis:
      "一名在商业与理想之间挣扎的年轻女演员，在香港电影圈的光影浮沉中逐渐看清自我。影片以细腻笔触描绘演艺行业背后的真实人生，舒淇凭此片获得香港电影金像奖最佳新演员及最佳女配角。",
    featured: true,
    highlight: "香港电影金像奖最佳新演员",
  },
  {
    id: "bo-li-zhi-cheng-1998",
    title: "玻璃之城",
    enTitle: "City of Glass",
    year: 1998,
    type: "电影",
    genre: "爱情",
    director: "张婉婷",
    role: "韵文",
    rating: 7.8,
    popularity: 78,
    poster:
      "https://readdy.ai/api/search-image?query=a%20nostalgic%20young%20woman%20in%20a%20sunlit%20old%20university%20corridor%20holding%20a%20letter%20cinematic%20Chinese%20romance%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-bolizhicheng-1998&orientation=portrait",
    synopsis:
      "跨越数十年的爱情故事，在时代的洪流与城市的变迁中缓缓展开。舒淇饰演的韵文，用一生守候一段未能圆满的感情，成为华语影史令人难忘的爱情经典。",
    featured: true,
    highlight: "华语影史经典爱情片",
  },
  {
    id: "bo-li-zun-1999",
    title: "玻璃樽",
    enTitle: "Gorgeous",
    year: 1999,
    type: "电影",
    genre: "喜剧",
    director: "谷德昭",
    role: "沈悦",
    rating: 6.9,
    popularity: 72,
    poster:
      "https://readdy.ai/api/search-image?query=a%20cheerful%20young%20woman%20on%20a%20sunny%20seaside%20promenade%20with%20a%20bottle%20in%20hand%20cinematic%20Chinese%20comedy%20romance%20movie%20poster%20portrait%20composition%20bright%20warm%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20neutral%20beige%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-bolizun-1999&orientation=portrait",
    synopsis:
      "一场因漂流瓶结缘的浪漫追逐，俏皮又温暖。舒淇以灵动表演诠释都市女孩对爱情与生活的向往，展现其喜剧天赋与亲和力。",
  },
  {
    id: "qian-xi-man-bo-2001",
    title: "千禧曼波",
    enTitle: "Millennium Mambo",
    year: 2001,
    type: "电影",
    genre: "剧情",
    director: "侯孝贤",
    role: "Vicky",
    rating: 7.4,
    popularity: 70,
    poster:
      "https://readdy.ai/api/search-image?query=a%20restless%20young%20woman%20walking%20through%20a%20long%20neon%20tunnel%20at%20midnight%20cinematic%20Chinese%20arthouse%20movie%20poster%20portrait%20composition%20moody%20blue%20free%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-qianximanbo-2001&orientation=portrait",
    synopsis:
      "以千禧年台北为背景，记录一代年轻人的迷惘与漂泊。舒淇饰演的 Vicky 在都市夜色里游走，成为侯孝贤镜头下最具时代气息的女性形象之一。",
  },
  {
    id: "zui-hao-de-shi-guang-2005",
    title: "最好的时光",
    enTitle: "Three Times",
    year: 2005,
    type: "电影",
    genre: "爱情",
    director: "侯孝贤",
    role: "秀美 / 艺旦 / 陈颖",
    rating: 7.7,
    popularity: 82,
    poster:
      "https://readdy.ai/api/search-image?query=a%20graceful%20woman%20in%20three%20eras%20of%20Chinese%20history%20under%20soft%20window%20light%20cinematic%20Chinese%20romance%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-zuihaodeshiguang-2005&orientation=portrait",
    synopsis:
      "三段跨越时代的爱情，三种不同的深情。舒淇一人分饰三角，以极简的表演传递浓烈情感，凭本片荣获金马奖最佳女主角，被誉为其演技巅峰之作。",
    featured: true,
    highlight: "金马奖最佳女主角",
  },
  {
    id: "fei-cheng-wu-rao-2008",
    title: "非诚勿扰",
    enTitle: "If You Are the One",
    year: 2008,
    type: "电影",
    genre: "喜剧",
    director: "冯小刚",
    role: "梁笑笑",
    rating: 7.1,
    popularity: 90,
    poster:
      "https://readdy.ai/api/search-image?query=a%20wistful%20young%20woman%20gazing%20across%20a%20misty%20lake%20in%20Hokkaido%20cinematic%20Chinese%20romance%20comedy%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-feichengwurao-2008&orientation=portrait",
    synopsis:
      "一场别开生面的相亲之旅，笑中带泪。舒淇饰演的梁笑笑真挚又倔强，与银幕搭档的化学反应成为影片最大亮点，票房口碑双丰收。",
    featured: true,
    highlight: "年度票房冠军",
  },
  {
    id: "fei-cheng-wu-rao-2-2010",
    title: "非诚勿扰2",
    enTitle: "If You Are the One 2",
    year: 2010,
    type: "电影",
    genre: "爱情",
    director: "冯小刚",
    role: "梁笑笑",
    rating: 6.8,
    popularity: 80,
    poster:
      "https://readdy.ai/api/search-image?query=a%20contemplative%20woman%20in%20a%20warm%20autumn%20forest%20with%20soft%20haze%20cinematic%20Chinese%20romance%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-feichengwurao2-2010&orientation=portrait",
    synopsis:
      "延续前作的幽默与深情，探讨婚姻与别离。舒淇再度演绎梁笑笑，用细腻情绪刻画成人世界里关于爱与放手的复杂命题。",
  },
  {
    id: "xi-you-jiang-mo-2013",
    title: "西游·降魔篇",
    enTitle: "Journey to the West: Conquering the Demons",
    year: 2013,
    type: "电影",
    genre: "奇幻",
    director: "周星驰",
    role: "段小姐",
    rating: 6.9,
    popularity: 92,
    poster:
      "https://readdy.ai/api/search-image?query=a%20fearless%20female%20demon%20hunter%20with%20flowing%20robes%20in%20a%20misty%20ancient%20courtyard%20cinematic%20Chinese%20fantasy%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-xiyouxiangmo-2013&orientation=portrait",
    synopsis:
      "周星驰执导的奇幻喜剧巨制。舒淇化身敢爱敢恨的段小姐，灵动又深情，为这段降魔传奇注入了最动人的情感内核。",
    featured: true,
    highlight: "华语奇幻票房神话",
  },
  {
    id: "yi-bu-zhi-yao-2014",
    title: "一步之遥",
    enTitle: "Gone with the Bullets",
    year: 2014,
    type: "电影",
    genre: "喜剧",
    director: "姜文",
    role: "完颜英",
    rating: 6.5,
    popularity: 74,
    poster:
      "https://readdy.ai/api/search-image?query=a%20glamorous%20woman%20in%20a%20vintage%20art%20deco%20ballroom%20under%20golden%20spotlight%20cinematic%20Chinese%20period%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-yibuzhiyao-2014&orientation=portrait",
    synopsis:
      "民国上海滩的浮华与荒诞。舒淇饰演的完颜英耀眼而神秘，在姜文浓烈的影像风格中留下一抹令人难忘的艳色。",
  },
  {
    id: "ci-ke-nie-ying-niang-2015",
    title: "刺客聂隐娘",
    enTitle: "The Assassin",
    year: 2015,
    type: "电影",
    genre: "武侠",
    director: "侯孝贤",
    role: "聂隐娘",
    rating: 7.3,
    popularity: 76,
    poster:
      "https://readdy.ai/api/search-image?query=a%20lone%20female%20swordsman%20in%20flowing%20black%20robes%20amid%20misty%20mountains%20cinematic%20Chinese%20martial%20arts%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-cikeniyingniang-2015&orientation=portrait",
    synopsis:
      "侯孝贤执导、荣获戛纳电影节最佳导演的武侠史诗。舒淇饰演的聂隐娘沉默隐忍，于极简的影像中演绎一段关于道义与抉择的孤独之旅。",
    featured: true,
    highlight: "戛纳电影节最佳导演",
  },
  {
    id: "xun-long-jue-2015",
    title: "寻龙诀",
    enTitle: "Mojin: The Lost Legend",
    year: 2015,
    type: "电影",
    genre: "冒险",
    director: "乌尔善",
    role: "Shirley 杨",
    rating: 7.0,
    popularity: 88,
    poster:
      "https://readdy.ai/api/search-image?query=a%20bold%20female%20adventurer%20with%20a%20lantern%20in%20an%20ancient%20underground%20tomb%20cinematic%20Chinese%20adventure%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-xunlongjue-2015&orientation=portrait",
    synopsis:
      "华语冒险巨制，探秘地宫秘境。舒淇饰演的 Shirley 杨飒爽干练，在惊险旅程中展现女性角色的力量与智慧。",
    featured: true,
    highlight: "华语冒险片票房前列",
  },
  {
    id: "jian-wang-cun-2017",
    title: "健忘村",
    enTitle: "The Village of No Return",
    year: 2017,
    type: "电影",
    genre: "喜剧",
    director: "陈玉勋",
    role: "秋蓉",
    rating: 6.6,
    popularity: 66,
    poster:
      "https://readdy.ai/api/search-image?query=a%20curious%20village%20woman%20in%20a%20whimsical%20old%20Chinese%20town%20at%20dusk%20cinematic%20Chinese%20comedy%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-jianwangcun-2017&orientation=portrait",
    synopsis:
      "一段荒诞又温情的村庄寓言。舒淇挑战喜剧表演，以收放自如的演技塑造出一个层次丰富、令人又爱又叹的女性角色。",
  },
  {
    id: "shi-jian-you-ta-2021",
    title: "世间有她",
    enTitle: "Hero",
    year: 2021,
    type: "电影",
    genre: "剧情",
    director: "张艾嘉 / 李少红 / 陈冲",
    role: "沈玥",
    rating: 6.4,
    popularity: 64,
    poster:
      "https://readdy.ai/api/search-image?query=a%20resilient%20woman%20looking%20out%20of%20a%20city%20apartment%20window%20at%20dawn%20cinematic%20Chinese%20drama%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-shijianyyouta-2021&orientation=portrait",
    synopsis:
      "由三位女导演联合执导的女性题材电影。舒淇饰演的沈玥，在生活的重压下依然坚韧生长，诠释了普通女性身上不普通的力量。",
  },
  {
    id: "zui-hao-de-xiang-yu-2023",
    title: "最好的相遇",
    enTitle: "The Best Meet",
    year: 2023,
    type: "电影",
    genre: "剧情",
    director: "哈智超",
    role: "曹卢医",
    rating: 6.7,
    popularity: 68,
    poster:
      "https://readdy.ai/api/search-image?query=a%20warm%20gentle%20woman%20meeting%20a%20child%20in%20a%20sunlit%20park%20cinematic%20Chinese%20drama%20movie%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-zuihaodexiangyu-2023&orientation=portrait",
    synopsis:
      "聚焦特殊群体的温情之作。舒淇以克制而深情的表演，讲述关于陪伴、理解与生命尊严的动人故事，收获观众广泛好评。",
  },
  {
    id: "shi-liu-ge-xia-tian-2014",
    title: "十六个夏天",
    enTitle: "The Way We Were",
    year: 2014,
    type: "电视剧",
    genre: "爱情",
    director: "许肇任",
    role: "唐家妮",
    rating: 7.5,
    popularity: 72,
    poster:
      "https://readdy.ai/api/search-image?query=a%20young%20woman%20reminiscing%20in%20a%20summer%20sunlit%20schoolyard%20cinematic%20Chinese%20television%20drama%20poster%20portrait%20composition%20moody%20dramatic%20lighting%20soft%20film%20grain%20elegant%20minimal%20background%20warm%20neutral%20and%20rose%20tones%20professional%20high%20detail&width=600&height=900&seq=work-shiliugexiatian-2014&orientation=portrait",
    synopsis:
      "一段绵延十六年的青春情感长卷。舒淇饰演的唐家妮，用细腻演技串联起成长岁月里的遗憾与温柔，引发无数观众的青春共鸣。",
  },
] as const;